import React, { useState, useEffect } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import { ChromePicker } from 'react-color'
import api from './Services';
import { useNavigate } from "react-router";
import {  X, Plus, Edit, Trash2} from 'lucide-react';

export default function Projects(props) {
  const navigate = useNavigate();
  const [showEntryModal, setShowEntryModal] = useState({visible: false, modalContent:''});
  const initialFormDataProjects = {project_name: '', client: ''}
  const [formDataProjects, setFormDataProjects] = useState(initialFormDataProjects);
  const initialFormDataClients = {client_name: '', address: '', rate: '', contact_email: '', contact_phone: '', color: '#666666'}
  const [formDataClients, setFormDataClients] = useState(initialFormDataClients);
  const [editingEntryProject, setEditingEntryProject] = useState('');
  const [editingEntryClient, setEditingEntryClient] = useState('');





/* ==============
  SUBMIT PROJECT
  =============*/

  const handleSubmitProject = async (e) => {
    e.preventDefault();

    if (!formDataProjects.project_name) return;
    const entryData = {
      status: 'publish',
      title: formDataProjects.project_name,
      acf: {
        client: [formDataProjects.client]
      }
    };
   //return console.log('entryData', entryData)


    if (editingEntryProject) {
      api
          .put(`/wp-json/wp/v2/projects/${editingEntryProject.ID}`, entryData)
          .then((response) => {
            props.fetchClientsProjects()
            setFormDataProjects(initialFormDataProjects)
            setEditingEntryProject(null);
            handleModalVisibility()
           })
          .catch((err) => {
              console.log(err.message);
              if (err.status === 400) {
                navigate('/login')
              }
          });
    }
    else if (!editingEntryProject) {
      api
          .post('/wp-json/wp/v2/projects', entryData)
          .then((response) => {
            props.fetchClientsProjects()
            setFormDataProjects(initialFormDataProjects)
            handleModalVisibility()
           })
          .catch((err) => {
              console.log(err.message);
              if (err.status === 400) {
                navigate('/login')
              }
          });
    }
  };
  

/* ==============
  EDIT PROJECT
  =============*/
  
  const handleEditProject = (clientID, project) => {
    console.log('handleEditProject', project)
    setEditingEntryProject(clientID, project);
    setFormDataProjects({
      project_name: project.post_title,
      client: clientID
    });
    setShowEntryModal({visible: true, content: 'project'});
  };


 /* ==============
  DELETE PROJECT
  =============*/

  const handleDeleteProject = async (proj) => {

    if (!window.confirm(`Are you sure you want to delete "${proj.post_title}"?`)) return;
    api
      .delete(`/wp-json/projectman/v1/projects/${proj.ID}`)
      .then((response) => {
          props.fetchClientsProjects()
          setFormDataProjects(initialFormDataProjects)
       })
      .catch((err) => {
          console.log(err.message);
          if (err.status === 400) {
            navigate('/login')
          }
          if (err.status === 409) {
            alert(err.response.data.message)
            console.log(err);
          }

    });
  };



/* ==============
  SUBMIT CLIENT
  =============*/

  const handleSubmitClient = async (e) => {
    e.preventDefault();
//return console.log('formDataClients.color.rgb.r', formDataClients)
    if (!formDataClients.client_name) return;
    const entryData = {
      status: 'publish',
      title: formDataClients.client_name,
      acf: {
        color: formDataClients.color,
        address: formDataClients.address,
        rate: formDataClients.rate,
        contact_email: formDataClients.contact_email,
        contact_phone: formDataClients.contact_phone
      }
    };
   //return console.log('editingEntryClient', editingEntryClient)


    if (editingEntryClient) {
      api
          .put(`/wp-json/wp/v2/client/${editingEntryClient.ID}`, entryData)
          .then((response) => {
            props.fetchClientsProjects()
            setFormDataClients(initialFormDataClients)
            setEditingEntryClient(null);
            handleModalVisibility()
           })
          .catch((err) => {
              console.log(err.message);
              if (err.status === 400) {
                navigate('/login')
              }
          });
    }
    else if (!editingEntryClient) {
      api
          .post('/wp-json/wp/v2/client', entryData)
          .then((response) => {
            props.fetchClientsProjects()
            setFormDataClients(initialFormDataClients)
            handleModalVisibility()
           })
          .catch((err) => {
              console.log(err.message);
              if (err.status === 400) {
                navigate('/login')
              }
          });
    }
  };
  

/* ==============
  EDIT CLIENT
  =============*/
  
  const handleEditClient = (client) => {
    setEditingEntryClient(client);
    setFormDataClients({
      client_name: client.client_name,
      address: client.address,
      rate: client.rate,
      contact_email: client.email ,
      contact_phone: client.phone,
      color: {r: client.color.red , g:client.color.green , b: client.color.blue, a:client.color.alpha } 
    });
    setShowEntryModal({visible: true, content: 'client'});
  };


 /* ==============
  DELETE CLIENT
  =============*/

  const handleDeleteClient = async (client) => {

    if (!window.confirm(`Are you sure you want to delete "${client.client_name}"?`)) return;
    api
      .delete(`/wp-json/wp/v2/client/${client.ID}`)
      .then((response) => {
          props.fetchClientsProjects()
          setFormDataClients(initialFormDataClients)
       })
      .catch((err) => {
          console.log(err.message);
          if (err.status === 400) {
            navigate('/login')
          }
          if (err.status === 409) {
            alert(err.response.data.message)
            console.log(err);
          }

    });
  };




 /* ==============
  MODAL
  =============*/
  
  const handleModalVisibility = (content) => {
    setShowEntryModal({visible: !showEntryModal.visible, content: content});
    
  };
  

const handleColorChange = (color) => {
  setFormDataClients({...formDataClients, color: color.hex })
  console.log('color', color)
}


 /* ==============
  RENDER IT!
  =============*/
  

  return (

    <>  

    <div className="flex w-full justify-center px-4 pt-8">
      <div className="w-full">
        <TabGroup defaultIndex={0}>
          <TabList className="flex gap-4">
              <Tab
                key='Projects'
                className="rounded-full px-4 py-2 text-lg font-semibold text-stone-800  data-[hover]:bg-stone-300 data-[selected]:bg-stone-300 data-[selected]:data-[hover]:bg-stone-300"
              >
                Projects
              </Tab>
              <Tab
                key='Clients'
                className="rounded-full px-4 py-2 text-lg font-semibold text-stone-800  data-[hover]:bg-stone-300 data-[selected]:bg-stone-300 data-[selected]:data-[hover]:bg-stone-300"
              >
                Clients
              </Tab>

          </TabList>
          <TabPanels className="mt-3">
              <TabPanel key='Projects' className="rounded-xl bg-white p-6">
  
                <div className="flex justify-between mb-2">
                  <h2 className="text-3xl font-semibold">Projects</h2>
                  <button
                    onClick={() => handleModalVisibility('project')}
                    className="text-gray-100 bg-gray-700 hover:bg-gray-700/70 rounded-full px-4 py-2 transition-all"
                    title="Add entry"
                  ><Plus className="inline w-3 h-3 mr-2 text-gray-100" />
                     Add Project
                  </button>
                </div>

                  {props.clientsProjects.length == 0 && 'No Projects.' }

                  {props.clientsProjects.map((client, index) => 
                      <div key={`empty-${client.ID}`} className="py-2 border-b-4 last:border-0 border-stone-300 text-sm">
                          <div className="flex items-center font-bold">{client.client_name}
                              <div style={{ 
                                  background: client.color
                                }} 
                                className="w-2 h-2 inline-block ml-2 rounded-full">
                                &nbsp;
                              </div> 
                          </div>
                          <div className="">
                            {client.projects.map( proj => 
                              <div key={proj.ID}  className="flex justify-between py-1 border-b last:border-0 border-stone-300">
                                <div className="">
                                  {proj.post_title}
                                </div>
                                <div className="">
                                  <button className="mr-2" onClick={() => handleEditProject(client.ID, proj)}><Edit className="w-3 h-3" /></button>
                                  <button className="mr-2" onClick={() => handleDeleteProject(proj)}><Trash2 className="w-3 h-3" /></button>
                                </div>
                              </div>
                            )}
                          </div>
                      </div>

                  )}
              </TabPanel>

              <TabPanel key='Clients' className="rounded-xl bg-white p-6">        
                <div className="flex justify-between  mb-2">
                  <h2 className="text-3xl font-semibold">Clients</h2>
                  <button
                    onClick={() => handleModalVisibility('client')}
                    className="text-gray-100 bg-gray-700 hover:bg-gray-700/70 rounded-full px-4 py-2 transition-all"
                    title="Add Client"
                  ><Plus className="inline w-3 h-3 mr-2 text-gray-100" />
                     Add Client
                  </button>
                </div>

                  {props.clientsProjects.length == 0 && 'No Clients.' }

                  {props.clientsProjects.map((client, index) => 
                      <div key={`empty-${client.ID}`} className="flex justify-between p-2 border-b-4 last:border-0 border-stone-300 text-sm">
                        <div>
                          <div className="flex items-center font-bold">{client.client_name}
                              <div style={{ 
                                  background: client.color
                                }} 
                                className="w-2 h-2 inline-block ml-2 rounded-full">
                                &nbsp;
                              </div>
                          </div>
                          <div className="">Rate: ${client.rate}</div> 
                          <div><a className="text-blue-800" href={`mailto:${client.email}`}>{client.email}</a></div> 
                          <div className="">{client.phone}</div> 
                        </div>
                        <div className="">
                          <button className="mr-2" onClick={() => handleEditClient(client)}><Edit className="w-3 h-3" /></button>
                          <button className="mr-2" onClick={() => handleDeleteClient(client)} ><Trash2 className="w-3 h-3" /></button>
                        </div>

                      </div>

                  )}
              </TabPanel>              
          </TabPanels>
        </TabGroup>
      </div>
    </div>





{/* MODAL ======  */}
        {showEntryModal.visible && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800">
                  {editingEntryProject ? 'Edit Project' : 'Add Project'}
                </h3>
                <button
                  onClick={handleModalVisibility}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

      {/* FORM PROJECTS======  */}
          {showEntryModal.content == 'project' &&
            <form className="" onSubmit={handleSubmitProject}>

              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Client
                </label>
                  <select name="client" value={formDataProjects.client} onChange={(e) => setFormDataProjects({ ...formDataProjects, client: e.target.value })}>
                      <option disabled value=''>Select Client</option>
                    {props.clients.map(client => 
                      <option key={client.id} value={client.id}>{client.title.rendered}</option>
                      )}
                  </select>
              </div>

              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Project Name
                </label>
                <input
                  type="text"
                  value={formDataProjects.project_name}
                  onChange={(e) => setFormDataProjects({ ...formDataProjects, project_name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  rows="3"
                  placeholder="Project Name"
                />
              </div>
              

              <div className="mb-3">
                <button
                  type="submit"
                  className="text-gray-100 bg-gray-700 hover:bg-gray-700/70 rounded-full px-4 py-2 transition-all"
                  >Submit
                </button>
              </div>
            </form>
          }

      {/* FORM CLIENTS======  */}
          {showEntryModal.content == 'client' &&

            <form className="" onSubmit={handleSubmitClient}>

              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Client Name
                </label>
                <input
                  type="text"
                  value={formDataClients.client_name}
                  onChange={(e) => setFormDataClients({ ...formDataClients, client_name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  placeholder="Client Name"
                />
              </div>
              
              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Address
                </label>
                <textarea
                  value={formDataClients.address}
                  onChange={(e) => setFormDataClients({ ...formDataClients, address: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  rows="3"
                  placeholder="Address"
                />

              </div>

              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Rate
                </label>
                <input
                  type="number"
                  value={formDataClients.rate}
                  onChange={(e) => setFormDataClients({ ...formDataClients, rate: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  placeholder="0.00"
                />
              </div>
              
              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Contact Email
                </label>
                <input
                  type="email"
                  value={formDataClients.contact_email}
                  onChange={(e) => setFormDataClients({ ...formDataClients, contact_email: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  placeholder="name@email.com"
                />
              </div>
              
              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Contact Phone
                </label>
                <input
                  type="phone"
                  value={formDataClients.contact_phone}
                  onChange={(e) => setFormDataClients({ ...formDataClients, contact_phone: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  placeholder="xxx-xxx-xxxx"
                />
              </div>

              <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Color
                </label>
                <ChromePicker 
                  color={formDataClients.color}
                  onChange={(color) => handleColorChange(color)}
                  //onChangeComplete={(color) => setFormDataClients({...formDataClients, color: color.hex })}
                />
              </div>  

              <div className="mb-3">
                <button
                  type="submit"
                  className="text-gray-100 bg-gray-700 hover:bg-gray-700/70 rounded-full px-4 py-2 transition-all"
                  >Submit
                </button>
              </div>
            </form>
          }

            </div>
          </div>
        )}


  </>
  );
}
